"use client";

import { useEffect } from "react";
import { useAuthStore } from "store/authStore";

export const useAuthUser = () => useAuthStore((state) => state.user);
export const useAuthLoading = () => useAuthStore((state) => state.loading);
export const useAuthInitialized = () =>
  useAuthStore((state) => state.initialized);
export const useAuthRedirect = () => useAuthStore((state) => state.isRedirect);

export const useAuthLogin = () => useAuthStore((state) => state.login);
export const useAuthRegister = () => useAuthStore((state) => state.register);
export const useAuthLogout = () => useAuthStore((state) => state.logout);
export const useAuthFetchMe = () => useAuthStore((state) => state.fetchMe);
export const useAuthRefresh = () =>
  useAuthStore((state) => state.refreshSession);
export const useAuthSetRedirect = () =>
  useAuthStore((state) => state.setRedirect);

export const useAuthInit = () => {
  const initialize = useAuthStore((state) => state.initialize);
  useEffect(() => {
    initialize();
  }, [initialize]);
};
